/**
 * Created by lihanying on 2017/6/29.
 */

export const GETCLUBMEMBERLIST = 'GETCLUBMEMBERLIST'
export const GETCLUBLEVEL = 'GETCLUBLEVEL'
export const GETCLUBWALLETINFO = 'GETCLUBWALLETINFO'
export const GETCLUBWALLETRECORD = 'GETCLUBWALLETRECORD'
export const GETCLUBBOUGHT = 'GETCLUBBOUGHT'
export const GETCLUBPAYMENTTYPE = 'GETCLUBPAYMENTTYPE'
export const GETCLUBDIAMOND = 'GETCLUBDIAMOND'
export const GETCLUBDIAMONDRECORD = 'GETCLUBDIAMONDRECORD'
export const GETFOOTPRINTRECORD = 'GETFOOTPRINTRECORD'
export const GETRECORDDETAIL = 'GETRECORDDETAIL'
export const GETFOOTPRINTRECORDDETAIL = 'GETFOOTPRINTRECORDDETAIL'


// WEBPACK FOOTER //
// ./src/containers/ClubMemberList/constants.js